import { Theme, alpha } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { UiAlpha } from '../../../styles/ui-alpha';

export const useStyles = makeStyles<Theme>()((theme) => ({
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
    width: '100%',
  },
  iconBadge: {
    ...theme.mixins.appIconTintSquare,
    backgroundColor: alpha(theme.palette.primary.main, UiAlpha.Tint),
    color: theme.palette.primary.main,
  },
  topIcon: {
    width: 28,
    height: 28,
    display: 'block',
  },
  description: {
    width: '100%',
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  hint: {
    width: '100%',
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: theme.spacing(2),
    marginTop: theme.spacing(0.5),
  },
  actionButton: {
    width: '100%',
  },
  buttonIcon: {
    width: 20,
    height: 20,
    display: 'block',
  },
  closeButton: {
    width: '100%',
  },
  iosGuide: {
    width: '100%',
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1.25, 1.5),
    backgroundColor: alpha(theme.palette.primary.main, UiAlpha.Tint),
    color: theme.palette.text.primary,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.75),
    textAlign: 'left',
  },
}));
